import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { AnimatedAvatar, type AvatarBehavior } from '@/shared/features/user-avatar';
import { Button } from '@/ui_v3';
import { type AvatarDecorateForm } from '../schema';
import { AvatarMotionToggle } from './AvatarMotionToggle';
import { DownloadAvatarButton } from './DownloadAvatarButton';
import { RandomAvatarButton } from './RandomAvatarButton';

/**
 * 우측 프리뷰 패널 — 코어 DecorateAvatarModalContent 우측 섹션 1:1 재현.
 * 상단: 다운로드/랜덤 / 중앙: 전신 애니메이션 아바타(scale 2x) / 하단: 모션 토글 + 저장.
 */
export const AvatarPreviewPanel = ({
  onSave,
  isSaving
}: {
  onSave: () => void;
  isSaving?: boolean;
}) => {
  const {
    t
  } = useTranslation('common');
  const {
    watch,
    formState
  } = useFormContext<AvatarDecorateForm>();
  const avatar = watch('avatar');
  const [selectedMotion, setSelectedMotion] = useState<AvatarBehavior>('stand');
  return <div className="flex h-full flex-col bg-gray-50" data-sentry-component="AvatarPreviewPanel" data-sentry-source-file="AvatarPreviewPanel.tsx">
      <div className="flex shrink-0 justify-end gap-xs p-md">
        <DownloadAvatarButton data-sentry-element="DownloadAvatarButton" data-sentry-source-file="AvatarPreviewPanel.tsx" />
        <RandomAvatarButton data-sentry-element="RandomAvatarButton" data-sentry-source-file="AvatarPreviewPanel.tsx" />
      </div>

      <div className="flex flex-1 items-center justify-center">
        <div className="flex h-[128px] w-[96px] items-center justify-center">
          <AnimatedAvatar avatarData={avatar} behavior={selectedMotion} className="origin-center scale-[2]" data-sentry-element="AnimatedAvatar" data-sentry-source-file="AvatarPreviewPanel.tsx" />
        </div>
      </div>

      <div className="flex shrink-0 flex-col gap-sm px-lg pb-[18px] pt-sm">
        <div className="flex justify-center">
          <AvatarMotionToggle selectedMotion={selectedMotion} onMotionChange={setSelectedMotion} data-sentry-element="AvatarMotionToggle" data-sentry-source-file="AvatarPreviewPanel.tsx" />
        </div>
        <Button variant="contained" intent="strong" size="sm" className="w-full" disabled={!formState.isDirty || isSaving} onClick={onSave} data-sentry-element="Button" data-sentry-source-file="AvatarPreviewPanel.tsx">
          {t('avatarDecorate.save')}
        </Button>
      </div>
    </div>;
};